module.exports = __webpack_public_path__ + "static/media/Startup.12c95e01.png";